export enum UnitsConstants {
  GET_UNITS_REQUEST = 'GET_UNITS_REQUEST',
  GET_UNITS_SUCCESS = 'GET_UNITS_SUCCESS',
  GET_UNITS_FAILED = 'GET_UNITS_FAILED',

  ADD_FRACTIONS_TO_UNIT_REQUEST = 'ADD_FRACTIONS_TO_UNIT_REQUEST',
  ADD_FRACTIONS_TO_UNIT_SUCCESS = 'ADD_FRACTIONS_TO_UNIT_SUCCESS',
  ADD_FRACTIONS_TO_UNIT_FAILED = 'ADD_FRACTIONS_TO_UNIT_FAILED',
}
